module.exports = "/static/assets/74bde1e0cf8208279316d392a8e04f2c.png";